<template>
  <div class="app-select">
    <Field
      class="select-class"
      v-model="selectValue"
      is-link
      readonly
      :placeholder="$t('ep_admin_tips_select')"
      :disabled="disabled"
      @click="handleShow"
    />
    <Popup v-model:show="showPicker" round position="bottom">
      <Picker
        v-model="selectedValue"
        :columns="optionsList"
        :columns-field-names="customFieldName"
        confirm-button-text="Confirm"
        cancel-button-text="Cancel"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </Popup>
    <Field
      class="other-class"
      v-if="showOtherInput"
      v-model="otherValue"
      :placeholder="data.remind"
      style="margin-top: 8px"
      @blur="handleChange"
      :maxlength="500"
      show-word-limit
    />
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { Popup, Picker, Field } from 'vant'

const props = defineProps({
  data: {
    required: true,
    type: Object,
    default: {}
  },
  value: {
    required: true,
    type: String,
    default: undefined
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:value', 'change'])
const selectValue = ref(props.value)
const selectedValue = ref([])
const otherValue = ref('')
const optionId = ref('')
const showPicker = ref(false)
const customFieldName = {
  text: 'optionContent',
  value: 'id'
}

const optionsList = computed(() => {
  return (
    props.data?.optionsList?.map(item => {
      if (!item.id) {
        item.id = item.optionContent
      }
      return item
    }) || []
  )
})

const showOtherInput = computed(() => {
  return props.data?.optionsList?.some(item => {
    if (item.id) {
      return item.id === optionId.value && item.othersFlag === '1'
    } else {
      return item.optionContent === selectValue.value && item.othersFlag === '1'
    }
  })
})

const onConfirm = ({ selectedOptions }) => {
  showPicker.value = false
  selectValue.value = selectedOptions[0].optionContent
  optionId.value = selectedOptions[0].id
  const str = {
    optionId: selectedOptions[0].id,
    otherContent: showOtherInput.value ? otherValue.value : '',
    othersFlag: showOtherInput.value ? '1' : undefined
  }
  emit('change', selectValue.value ? [str] : [])
}
const handleShow = () => {
  if (props.disabled) return
  showPicker.value = true
}
const handleChange = () => {
  const str = {
    optionId: optionId.value ? optionId.value : selectValue.value,
    otherContent: showOtherInput.value ? otherValue.value : ''
  }
  emit('change', selectValue.value ? [str] : [])
}
onMounted(async () => {
  if (props.data.fieldValue) {
    selectedValue.value = [props.data.fieldValue[0].optionId]
    selectValue.value =
      props.data.optionsList.find(item => item.id == props.data.fieldValue[0].optionId)
        ?.optionContent || undefined
    otherValue.value = props.data.fieldValue[0]?.otherContent
      ? props.data.fieldValue[0].otherContent
      : undefined
  }
})
</script>

<style lang="less" scoped>
.app-select {
  width: 100%;
  .select-class {
    display: flex;
    align-items: center;
    height: 40px;
    line-height: 40px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    padding: 0 8px;
  }
  .other-class {
    padding: 2px 8px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.04);
    margin-top: 8px;
    border-bottom: none !important;
    padding-bottom: 0 !important;
  }
}
:deep(.van-field__word-limit) {
  border-bottom: none !important;
  padding-bottom: 0 !important;
}
:deep(.van-picker-column__wrapper) {
  li {
    padding: 0 12px;
    &::after {
      display: none;
    }
  }
}
</style>
